import { NavigateFunction } from "react-router-dom";
import CarouselCodewheelImg from "../assets/carousel-navigation/carousel-codewheel.png";
import CarouselJump from "../assets/carousel-navigation/carousel-jump.png";
import CarouselMaze from "../assets/carousel-navigation/carousel-maze.png";
import CarouselRobofly from "../assets/carousel-navigation/carousel-robofly.png";
import CarouselSki from "../assets/carousel-navigation/carousel-ski.png"

export type CarouselNavigatorNames = "games" | "activities" | "other";

export type CarouselImage = {
    src: string;
    link: string;
};

export class CarouselNavigatorManager {
    carouselNavigators: Map<CarouselNavigatorNames, CarouselNavigator>;

    constructor() {
        this.carouselNavigators = new Map();
    }

    addNavigator(
        name: CarouselNavigatorNames,
        setImages: (images: CarouselImage[]) => void,
        rerenderComponent: (rerenderState: boolean) => void,
        setHighlightedItem: (highlightedItem: any) => void,
        setIsVisible: (isVisible: boolean) => void,
        navigate: NavigateFunction
    ) {
        if (name === "games") {
            this._addGamesNavigator(name, setImages, rerenderComponent, setHighlightedItem, setIsVisible, navigate);
        }
    }

    _addGamesNavigator(name: CarouselNavigatorNames, setImages: (images: CarouselImage[]) => void, rerenderComponent: (rerenderState: boolean) => void, setHighlightedItem: (highlightedItem: any) => void, setIsVisible: (isVisible: boolean) => void, navigate: NavigateFunction) {
        const images: CarouselImage[] = [
            { src: CarouselJump, link: '/jumping-game' },
            { src: CarouselRobofly, link: '/robofly-game' },
            { src: CarouselSki, link: '/skiing-game' },
            { src: CarouselMaze, link: '/maze' },
            { src: CarouselCodewheelImg, link: '/codewheel' },
        ];
        this.carouselNavigators.set("games", new CarouselNavigator(name, images, rerenderComponent, setHighlightedItem, setIsVisible, navigate));
        setImages(images);
    }

    removeNavigator(name: CarouselNavigatorNames) {
        if (this.carouselNavigators.has(name)) {
            this.carouselNavigators.delete(name);
        }
    }
    getNavigator(name: CarouselNavigatorNames): CarouselNavigator | undefined {
        return this.carouselNavigators.get(name);
    }

}

class CarouselNavigator {
    currentIndex: number;

    constructor(
        public name: CarouselNavigatorNames,
        public images: CarouselImage[],
        public rerenderComponent: (rerenderState: boolean) => void,
        public setHighlightedItem: (highlightedItem: any) => void,
        public setIsVisible: (isVisible: boolean) => void,
        public navigate: NavigateFunction
    ) {
        this.currentIndex = 0;
        this.images = images;
    }

    highlightImage(index: number) {
        this.currentIndex = index;
        this.setHighlightedItem(this.images[index]);
        this.rerenderComponent(true);
    }
}